import flow from 'lodash/flow';
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { findDOMNode } from 'react-dom';
import { DragSource, DropTarget } from 'react-dnd';
import throttle from 'lodash/throttle';

import { ITEM_TYPE_NODE_RESPONSE_OPTION } from '../../constants/itemTypes';

class FormEditorEditQuestionOptionDragAndDropWrapper extends Component {
    static propTypes = {
        // Drag and drop.
        connectDragSource: PropTypes.func.isRequired,
        connectDragPreview: PropTypes.func.isRequired,
        connectDropTarget: PropTypes.func.isRequired,

        children: PropTypes.func.isRequired,
    };

    render() {
        return (
            // Connect drag preview here to show as preview a screenshot of the dragged node.
            this.props.connectDragPreview(
                // Connect drop target here so that each node works as a drop target.
                this.props.connectDropTarget(<div>{this.props.children(this.props.connectDragSource)}</div>),
            )
        );
    }
}

const dragSpec = {
    canDrag(props, monitor, component) {
        return true;
    },
    beginDrag(props, monitor, component) {
        const { optionId, beginDragOption } = props;
        beginDragOption(optionId);
        return { optionId };
    },
    endDrag(props, monitor, component) {
        props.endDragOption(props.optionId);
    },
};

const dragCollect = (connect, monitor) => ({
    connectDragSource: connect.dragSource(),
    connectDragPreview: connect.dragPreview(),
    isDragging: monitor.isDragging(),
});

const dropSpec = (() => {
    // Make sure we're hovering over something different
    let hoverMemo;
    return {
        canDrop(props, monitor, component) {
            return true;
        },
        hover: throttle((props, monitor, component) => {
            const clientOffset = monitor.getClientOffset();
            if (!clientOffset) {
                return;
            }
            const { optionId, hoverOption } = props;
            const { y } = clientOffset;
            const hoverKey = y;
            if (hoverKey !== hoverMemo) {
                hoverMemo = hoverKey;

                // Perform DOM measurement to figure out the drop location
                // eslint-disable-next-line react/no-find-dom-node
                const el = findDOMNode(component);
                const { top, bottom } = el.getBoundingClientRect();
                const yPosition = (y - top) / (bottom - top);
                hoverOption(optionId, yPosition);
            }
        }, 50),
        drop(props, monitor, component) {
            const { optionId } = props;
            // Reset the hover
            hoverMemo = null;
            return { optionId };
        },
    };
})();

const dropCollect = (connect, monitor) => ({
    connectDropTarget: connect.dropTarget(),
});

const decoratedComponent = flow(
    DragSource(ITEM_TYPE_NODE_RESPONSE_OPTION, dragSpec, dragCollect),
    DropTarget(ITEM_TYPE_NODE_RESPONSE_OPTION, dropSpec, dropCollect),
)(FormEditorEditQuestionOptionDragAndDropWrapper);

// Prop types of the react-dnd decorated component.
decoratedComponent.propTypes = {
    optionId: PropTypes.string.isRequired,
    beginDragOption: PropTypes.func.isRequired,
    endDragOption: PropTypes.func.isRequired,
    hoverOption: PropTypes.func.isRequired,
};

export default decoratedComponent;
